export default "__VITE_ASSET__oXb9D$A$__"